/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedTabularProductRequestDto } from '../../models/backend-patched-tabular-product-request-dto';
import { BackendTabularProductDto } from '../../models/backend-tabular-product-dto';

export interface SalesTabularProductsPartialUpdate$FormData$Params {
  id: number;
  body?: BackendPatchedTabularProductRequestDto;
}

export function salesTabularProductsPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: SalesTabularProductsPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendTabularProductDto>> {
  const rb = new RequestBuilder(rootUrl, salesTabularProductsPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendTabularProductDto>;
    }),
  );
}

salesTabularProductsPartialUpdate$FormData.PATH = '/api/sales/tabular-products/{id}/';
